import type { RoadmapTab } from "./nav-items"

export type RoadmapEmptyAction = "clear-filters" | "view-hidden" | null

export interface RoadmapEmptyState {
	title: string
	text: string
	action: RoadmapEmptyAction
}

export function roadmapEmptyState({
	tabValue,
	hasActiveFilters,
	pendingCount,
}: {
	tabValue: RoadmapTab
	hasActiveFilters: boolean
	pendingCount: number
}): RoadmapEmptyState {
	if (tabValue === "pending" && hasActiveFilters && pendingCount > 0) {
		return {
			title: `Your filters hide all ${pendingCount} pending requests`,
			text: "Filters apply to this list too. Clear them to review what is waiting.",
			action: "clear-filters",
		}
	}

	if (hasActiveFilters) {
		return {
			title: "No requests match your filters",
			text: "Clear the filters to see everything in this view.",
			action: "clear-filters",
		}
	}

	switch (tabValue) {
		case "pending":
			return {
				title: "Everything is reviewed",
				text: "New requests imported from Linear land here. Publish them to share with customers, or hide them to keep them internal.",
				action: null,
			}
		case "hidden":
			return {
				title: "No hidden requests",
				text: "Requests you've hidden from customers stay here. They're still tracked internally but won't appear on your portal.",
				action: null,
			}
		case "all":
			return {
				title: "No requests yet",
				text: "Once you publish or hide Linear requests, they'll show up here.",
				action: null,
			}
		case "active":
			return {
				title: "No visible requests",
				text: "Published requests visible to your customers in their portal will appear here.",
				action: "view-hidden",
			}
	}
}
